import store from '../store';
import { history } from '../views/App/history';
import { toast } from 'react-toastify';
import IconToast from '../components/NewToast';
import { getGlobalIntl } from '../reduxConnectedIntlProvider';
import { setClientIdLocalStorage } from './client-navigation';
import { toggleDialog, toggleControl } from '../store/control/duck';
import { updateViewingClient } from '../store/client/duck';

// The quota helpers now live in ./gptQuota, which depends on nothing but
// localStorage and a constant. Re-exported here so that the thirty-odd
// existing `from './openai'` imports are unaffected — see that file for why
// the split exists.
import { getGPTQuota, validateGPTQuota, resetGPTQuota, decreaseGPTQuota } from './gptQuota';
export { getGPTQuota, validateGPTQuota, resetGPTQuota, decreaseGPTQuota };

export const shouldShowGPTDisclaimer = () => !localStorage.getItem('showedGPTDisclaimer');
export const setShouldShowGPTDisclaimer = () => localStorage.setItem('showedGPTDisclaimer', 'true');
export const resetGPTDisclaimer = () => localStorage.removeItem('showedGPTDisclaimer');

export const goToGPTOptions = client => {
  // Selected before the branch: the disclaimer dialog navigates to
  // /gpt-options by itself (ChatGPTDisclaimerDialog) and never sees the
  // client, so the once-per-device disclaimer path used to land on whoever
  // was open last. Harmless if the adviser cancels — they are on this client.
  // Guarded: ChatGPTFab calls this with `props.viewingClient`, which is
  // undefined whenever nothing is selected. Running the two writes anyway
  // REMOVES the stored id (setClientIdLocalStorage's own null branch) and
  // clears redux — throwing away the breadcrumb the A.I. page uses to recover
  // its client after a reload. No client means "leave the selection alone".
  if (client) {
    setClientIdLocalStorage(client._id);
    store.dispatch(updateViewingClient(client));
  }
  if (shouldShowGPTDisclaimer()) {
    store.dispatch(toggleDialog('chatGPTDisclaimer', {}));
  } else {
    history.push('/gpt-options');
  }
};

const handleFeedback = () => {
  console.log('handleFeedback');
  store.dispatch(
    toggleControl('chatGPTFeedbackDialog', {
      client: {},
      extraContent: 'GPT Quota Exceeded',
      onSubmit: () => {
        resetGPTQuota();
      }
    })
  );
};

export const handleError = (error, defaultOnClick = false) => {
  console.log(error);
  const intl = getGlobalIntl();
  if (error.message.includes('Token count exceeds')) {
    toast.info(IconToast('error', error.message), { className: 'new-toast' });
  } else if (error.message === 'Quota exceeded') {
    toast.info(IconToast('error', intl.formatMessage({ id: 'chat-gpt-quota-exceeded' })), {
      className: 'new-toast',
      onClick: defaultOnClick ? handleFeedback : undefined
    });
  } else if (error.message === 'gpt-invalid-request-type-error') {
    toast.info(IconToast('error', intl.formatMessage({ id: 'invalid-type-request-type' })), { className: 'new-toast' });
  } else if (error.message === 'gpt-insufficent-data-error') {
    toast.info(IconToast('error', intl.formatMessage({ id: 'gpt-insufficent-data-error' })), {
      className: 'new-toast'
    });
  } else if (error.message === 'gpt-unknown-error') {
    toast.info(IconToast('error', intl.formatMessage({ id: 'gpt-unknown-error' })), { className: 'new-toast' });
  }
};
